import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

import { InputField } from "../../../shared/ui/input-field/input-field";
import { Button } from "../../../shared/ui/button/button";
import { Sidebar } from '../../../core/services/sidebar';
import { Modal } from '../../../core/services/modal';
import { OtpModal } from '../../../shared/components/modals/otp-modal/otp-modal';
import { Popup } from '../../../core/services/popup';
import { Header } from '../../../core/services/header';
import { AuthStore } from '../../../core/services/auth-store';

@Component({
  selector: 'app-step1-applicant-details',
  imports: [TranslatePipe, ReactiveFormsModule, InputField, Button, CommonModule],
  templateUrl: './step1-applicant-details.html',
  styleUrl: './step1-applicant-details.css'
})

export class Step1ApplicantDetails {
  @Input() data: any;
  @Input() onboardingStep!: number;
  @Input() onboardingSubStep!: number;

  @Output() dataChange = new EventEmitter<any>();
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();
  referenceId: string | undefined | null = null;

  emailOtpVerified: boolean = false;
  mobileOtpVerified: boolean = false;

  applicantDetailsForm = new FormGroup({
    role: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(500)]),

    name: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(50),
    ]),

    email: new FormControl('', [
      Validators.required,
      Validators.email,
    ]),

    mobile: new FormControl('', [
      Validators.required,
      Validators.pattern(/^79\d{8}$/),
    ]),
  });

  constructor(private sidebarService: Sidebar,
    private modalService: Modal,
    private popup: Popup,
    private headerService: Header,
    private authStore: AuthStore
  ) { }

  ngOnInit() {
    if (this.data) this.applicantDetailsForm.patchValue(this.data);
    this.sidebarService.setLinks([{ label: 'SIDEBAR.CANCEL', route: '/', iconPath: 'assets/icons/cancel-blue.svg', variant: 'plain' }]);
  }

  onNext() {
    this.dataChange.emit(this.applicantDetailsForm.value);
    this.next.emit();
  }

  handleFormSubmission() {
    this.applicantDetailsForm.markAllAsTouched();

    if (this.applicantDetailsForm.valid) {
      const formData = this.applicantDetailsForm.value;

      // Todo: Call API service here
      // this.apiService.submitApplicantDetails(formData).subscribe({
      //   next: (response) => {
      //     console.log('Form submitted successfully:', response);
      //     this.next.emit(); // move to next step
      //   },
      //   error: (err) => {
      //     console.error('Error submitting form:', err);
      //   }
      // });

      this.getEmailOtpModal();

      console.log('Form data ready for submission:', formData);
    } else {
      //  Invalid form
      console.warn('Form is invalid');
    }
  }

  getEmailOtpModal() {
    const otpModalOptions = {
      backdropClosable: false,
      showCancelButton: true,
      showConfirmButton: true,
      textConfirmButton: 'OTP_MODAL.VERIFY',
      headerIconPath: 'assets/icons/mail.svg',
      title: 'OTP_MODAL.TITLE_EMAIL',
      message: 'OTP_MODAL.MESSAGE_EMAIL',
      email: this.applicantDetailsForm.get('email')?.value!,

      onSubmitOtp: (isOtpValid: boolean) => {
        this.emailOtpVerified = isOtpValid;
        console.log('OTP validation result:', this.emailOtpVerified);

        if (isOtpValid) {
          this.modalService.close();

          this.popup.show({
            message: 'Email verified',
            type: 'success',
            duration: 5000,
            position: 'bottom',
            icon: 'assets/icons/check-popup.svg',
          });

          //open mobile otp modal
          this.getMobileOtpModal();
        } else {
          console.log('Invalid OTP');
        }
      },

      onResendCode: () => {
        console.log('Resend code triggered');
        // TODO: call API to resend OTP
      },
    };

    this.modalService.open(OtpModal, otpModalOptions);
  }

  getMobileOtpModal() {
    const otpModalOptions = {
      backdropClosable: false,
      showCancelButton: true,
      showConfirmButton: true,
      textConfirmButton: 'OTP_MODAL.VERIFY',
      headerIconPath: 'assets/icons/mobile-verify.svg',
      title: 'OTP_MODAL.TITLE_MOBILE',
      message: 'OTP_MODAL.MESSAGE_MOBILE',
      mobile: this.applicantDetailsForm.get('mobile')?.value!,

      onSubmitOtp: (isOtpValid: boolean) => {
        this.mobileOtpVerified = isOtpValid;
        console.log('OTP validation result:', this.mobileOtpVerified);

        if (isOtpValid) {
          this.modalService.close();

          //Todo: at this point reference id is generated
          this.referenceId = '3489393';

          //remove sidebar links
          this.sidebarService.setLinks([]);

          //Set header configs
          this.headerService.updateConfig({
            showNotifications: false,
            showRightSection: true,
            dropdownOptions: [
              {
                label: 'HEADER.SAVE_EXIT',
                iconPath: 'assets/icons/logout.svg',
                action: () => this.authStore.logout()
              }
            ]
          });

        } else {
          console.log('Invalid OTP');
        }
      },

      onResendCode: () => {
        // console.log('Resend code triggered');
        // TODO: call API to resend OTP
      },
    };

    this.modalService.open(OtpModal, otpModalOptions);
  }

  copyReferenceId(referenceId: string) {
    navigator.clipboard.writeText(referenceId).then(() => {
      this.popup.show({
        message: 'BUSINESS_ONBOARDING.COPY_SUCCESS',
        type: 'success',
        duration: 2000,
        position: 'bottom',
        icon: 'assets/icons/check-popup.svg',
      });
    });
  }

  moveOnToCompanyDetailsStep() {
    this.next.emit();
  }

  back() {
    this.prev.emit();
  }

  getControl(controlName: string): FormControl {
    return this.applicantDetailsForm.get(controlName) as FormControl;
  }
}
